import { handleActions } from 'redux-actions';
import { success } from '../../actions/createSubscriber';
/**
 * Reducer intended for use to store a subscriber's information from Lucina.
 *
 * ```js
 * import { subscription } from '@minerva-analytics/pantheon';
 * const { subscriberInfo } = subscription.reducers;
 *
 * // To select data from this reducer in a component
 * import { useSelector } from 'react-redux';
 *
 * const Test = () => {
 *   // Note that you may need to change this depending on where the subscriber
 *   // model is integrated in your store
 *   const subscriberInfo = useSelector((state) => state.subscriber.subscriberInfo);
 *
 *   return <div>Test</div>
 * };
 * ```
 */

var subscriberInfo = handleActions(new Map([[success, function (state, action) {
  return action.payload;
}]]), null);
export default subscriberInfo;